
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { InferGetStaticPropsType } from "next";
import { getStaticPathsForPostDetail, getStaticPropsForPostDetail } from "@/utils/slug";
import ProjectLayout from '@/components/layout/site/posts/ProjectLayout';
import ArticleLayout from '@/components/layout/site/posts/ArticleLayout';

const GenericPost = ({ data }: InferGetStaticPropsType<typeof getStaticProps>) => {
  const post = data?.posts?.nodes?.[0];
  if (post?.layout?.layout === 'project') {
    return <ProjectLayout data={data} />
  } else {
    return <ArticleLayout data={data} />
  }
};

export default GenericPost;

 const _getStaticProps = getStaticPropsForPostDetail;
export const getStaticPaths = getStaticPathsForPostDetail;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/p/[category]/[slug]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  